import React from 'react';

import { Tooltip } from 'antd';

import { useEnvironnement } from 'hooks/EnvironementStoreContext';
import { DashboardAdminFonctionnelFilter } from 'pages/admin-fonctionnel/Dashboard/types';
import { FilterDashboardAutoriteFourriere } from 'pages/autorite-fourriere/Dashboard/DashboardHeader/Filters/types';
import { DashboardDSRFilter } from 'pages/delegue-securite-routiere/Dashboard/types';
import { DashboardFOFilter } from 'pages/forces-de-l-ordre/Dashboard/types';
import { FilterDashboardGardien } from 'pages/gardien-fourriere/Dashboard/DashboardHeader/Filters/types';
import { DashboardJusticeFilter } from 'pages/justice/Dashboard/types';

import { SearchBar } from '../index';

type FilterType =
  | DashboardDSRFilter
  | DashboardAdminFonctionnelFilter
  | FilterDashboardAutoriteFourriere
  | FilterDashboardGardien
  | DashboardFOFilter
  | DashboardJusticeFilter;

interface DashboardSearchBarWithTooltipProps {
  search?: string;
  filter: Partial<FilterType>;
  setFilter: (value: Partial<FilterType>) => void;
}

const DashboardSearchBarWithTooltip = ({
  search,
  filter,
  setFilter,
}: DashboardSearchBarWithTooltipProps) => {
  const [{ JUSTICE_ACTIVE_BOOL }] = useEnvironnement();

  const tooltipText = JUSTICE_ACTIVE_BOOL
    ? "Recherche par plaque d'immatriculation, parquet, procès verbal ou identifiant justice"
    : "Recherche par plaque d'immatriculation";

  const searchBarPlaceholder = JUSTICE_ACTIVE_BOOL
    ? 'Rechercher un dossier...'
    : 'Rechercher une plaque...';

  return (
    <Tooltip title={tooltipText}>
      <span>
        <SearchBar
          searchedStr={search}
          // Plates values are forced to uppercase
          triggerSearch={search =>
            setFilter({ ...filter, search: search?.toUpperCase() })
          }
          antdProps={{
            placeholder: searchBarPlaceholder,
            style: { maxWidth: 300 },
          }}
          rounded={true}
        />
      </span>
    </Tooltip>
  );
};

export default DashboardSearchBarWithTooltip;
